<template>
  <div class="ma-3">
    <form>
      <h1
        class="title font-weight-regular"
      >
        VÝSTUPNÉ HODNOTENIE PO ABSOLVOVANÍ ZRaVVP - {{ form.prisoner_full.string_details }}
      </h1>

      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Hodnotenie postoja odsúdeného k jeho trestnej činnosti &nbsp;
              <v-icon @click="showDialog('hodnotenie_postoja_odsudeneho')">
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.hodnotenie_postoja_odsudeneho"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Spáchanie trestného činu, za ktorý je odsúdený vôbec neľutuje."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Spáchanie trestného činu odsúdený neľutuje, resp. ľutuje len formálne."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Nevie zaujať stanovisko k spáchaniu trestného činu, za ktorý je odsúdený."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Spáchanie trestného činu, za ktorý je odsúdený ľutuje."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Spáchanie trestného činu, za ktorý je odsúdený, veľmi ľutuje."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Realistickosť hodnotenia vlastnej rodinnej situácie odsúdeného &nbsp;
              <v-icon
                @click="showDialog('realistickost_hodnotenia_vlastnej_rodinnej')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.realistickost_hodnotenia_vlastnej_rodinnej"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Veľmi nerealisticky hodnotí svoju rodinnú situáciu, vrátane správania a fungovania rodiny po jeho návrate z výkonu trestu."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Svoju rodinnú situáciu hodnotí z hľadiska viacerých aspektov skôr nerealisticky."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Svoju rodinnú situáciu hodnotí skôr realisticky."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Svoju rodinnú situáciu hodnotí realisticky, vrátane primeraných očakávaní o správaní sa členov rodiny po jeho návrate z výkonu trestu."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Svoju rodinnú situáciu hodnotí veľmi realisticky a zároveň sa po prepustení bude usilovať o dobré opätovné začlenenie do rodiny a prípadné pozitívne zmeny v nej."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Realistickosť hodnotenia osobnej situácie odsúdeného - zameraná na uvedomenie si osobných rizík v súvislosti s jeho správaním a osobnosťou &nbsp;
              <v-icon
                @click="showDialog('realistickost_hodnotenia_osobnej_situacie')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.realistickost_hodnotenia_osobnej_situacie"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Neuvedomuje si, resp. nerealisticky hodnotí svoje osobné identifikované rizikové faktory."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Má prevažne nedostatočný náhľad na svoje zaužívané správanie a osobnostné vlastnosti."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Má čiastočne realistický náhľad na svoje zaužívané správanie a osobnostné vlastnosti."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Uvedomuje si a prevažne realisticky hodnotí svoje osobné identifikované rizikové faktory."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Uvedomuje si a veľmi realisticky hodnotí identifikované rizikové faktory."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Motivácia odsúdeného k životu bez recidívy &nbsp;
              <v-icon
                @click="showDialog('motivacia_odsudeneho_k_zivotu_bez_recidivy')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.motivacia_odsudeneho_k_zivotu_bez_recidivy"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Celkovo sa dá konštatovať, že u odsúdeného je negatívna alebo chýbajúca motivácia k životu bez recidívy."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Z rozhovoru s odsúdeným a iných dostupných zdrojov vyplýva, že jeho motivácia k životu bez recidívy je viac negatívna a skôr nedostatočná pre úsilie o život bez recidívy."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Motivácia odsúdeného k životu bez recidívy je vo výsledku neprehľadná, ťažko určiteľná, s pozitívnymi aj rizikovými faktormi, ktoré vo výsledku vedú k tomu, že u odsúdeného nie je možné určiť prevahu pozitívnych vs rizikových motivačných faktorov k životu bez recidívy."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="U odsúdeného vo výsledku prevažujú pozitívne faktory motivácie k životu bez recidívy."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Motivácia odsúdeného k životu bez recidívy je veľmi pozitívna."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Plán života po prepustení &nbsp;
              <v-icon @click="showDialog('plan_zivota_po_prepusteni')">
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.plan_zivota_po_prepusteni"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Má výrazne nerealistický plán života po prepustení."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Má prevažne nerealistický plán života po prepustení."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Má čiastočne realistický plán života po prepustení."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Má pomerne špecifický a realistický plán."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Má výrazne špecifický a realistický plán."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Hodnotenie úrovne sociálnej komunikácie u odsúdeného &nbsp;
              <v-icon
                @click="showDialog('hodnotenie_urovne_socialnej_komunikacie')"
              >
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.hodnotenie_urovne_socialnej_komunikacie"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Vykazuje veľmi zlé schopnosti v rámci sociálnej komunikácie."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="Vykazuje horšie schopnosti v rámci sociálnej komunikácie."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="Vykazuje priemerné schopnosti v rámci sociálnej komunikácie."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="Vykazuje dobré schopnosti v rámci sociálnej komunikácie."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="Vykazuje veľmi dobré schopnosti v rámci sociálnej komunikácie."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-card>
            <v-card-title>
              Záverečné hodnotenie progresu u odsúdeného po pobyte vo VODD &nbsp;
              <v-icon @click="showDialog('zaverecne_hodnotenie')">
                mdi-information-outline
              </v-icon>
            </v-card-title>
            <v-card-text>
              <v-radio-group
                v-model="form.zaverecne_hodnotenie"
                :mandatory="true"
              >
                <v-radio
                  color="red"
                  label="Bez zlepšenia."
                  :value="4"
                />
                <v-radio
                  color="orange"
                  label="S minimálnym zlepšením."
                  :value="3"
                />
                <v-radio
                  color="yellow"
                  label="S miernym zlepšením."
                  :value="2"
                />

                <v-radio
                  color="blue"
                  label="S citeľným zlepšením."
                  :value="1"
                />

                <v-radio
                  color="green"
                  label="S výrazným zlepšením."
                  :value="0"
                />
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="error"
          @click="closeItem()"
        >
          Uzatvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-text
            v-for="(item, index) in dialog_item.texty"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },
  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      texty: [],
    },

    form: {
      id: null,
      motivacia_odsudeneho_k_pobytu: "",
      hodnotenie_postoja_odsudeneho: "",
      realistickost_hodnotenia_vlastnej_rodinnej: "",
      realistickost_hodnotenia_osobnej_situacie: "",
      motivacia_odsudeneho_k_zivotu_bez_recidivy: "",
      plan_zivota_po_prepusteni: "",
      hodnotenie_urovne_socialnej_komunikacie: "",
      zaverecne_hodnotenie: "",
      prisoner_full: {
        string_details: "",
      },
    },

    dialogs: {
      motivacia_odsudeneho_k_pobytu: {
        nazov: "Motivácia odsúdeného k pobytu vo VODD",
        texts: [
          "Vníma pobyt vo VODD vyslovene negatívne. Nemá záujem o zmenu, ktorú prináša pobyt vo VODD, nezaujíma sa o programy. Nedomnieva sa si, že vo VODD nadobudne nové vedomosti a zručnosti, ktoré by mu pomohli uľahčiť adaptáciu na život na slobode. Zvýšený počet návštev, telefonátov a možnosť opustenia ústavu nevníma ako výhodu VODD, nemá záujem ich využívať. Samoobslužný režim vo VODD vníma ako obťažujúci, musí vykonávať činnosti, s ktorými nie je stotožnený. Alternatívou je aj situácia, kedy odsúdený uvádza, že pobyt vo VODD akceptuje len preto, lebo si tu viac oddýchne oproti bežnému oddielu, vníma to ako „dovolenku“.",
          "Vníma pobyt vo VODD viac negatívne než pozitívne. Nedomnieva sa, že mu pobyt vo VODD a absolvovanie jednotlivých programov pomôže uľahčiť adaptáciu na život na slobode, nezatracuje túto možnosť, avšak  je skeptický. Zvýšený počet návštev, telefonátov a možnosť opustenia ústavu vníma skôr ako zbytočnosť vzhľadom ku krátkosti pobytu vo VODD, no nepopiera možnosť, že by to využil. Samoobslužné činnosti považuje skôr za obťažujúce.",
          "Vníma neutrálne pobyt vo VODD. Nevie posúdiť čo očakávať od pobytu vo VODD a jednotlivých programov ani to, či mu to pomôže uľahčiť adaptáciu na život na slobode. Prítomnosť možností zvýšeného počtu návštev, telefonátov a opustenia ústavu si zatiaľ neuvedomuje, podobne ako prítomnosť samoobslužných činností vo VODD.",
          "Vníma pozitívne pobyt vo VODD. Očakáva nadobudnutie nových vedomostí, zručností. Nie je si istý, či mu krátky pobyt vo VODD a absolvovanie programov pomôže lepšie sa adaptovať na život na slobode. Zvýšený počet návštev, telefonátov a možnosť opustenia ústavu vníma ako kladnú stránku VODD. Samoobslužný režim vo VODD vníma skôr ako výhodu, aj keď poukazuje na to, že mu to uberie z jeho voľného času.",
          "Vníma veľmi pozitívne pobyt vo VODD. Očakáva nadobudnutie nových vedomostí, zručností. Verí, že mu absolvovanie programov vo VODD pomôže lepšie sa adaptovať na život na slobode. Vníma pozitívne zvýšený počet návštev, telefonátov a možnosť opustenia ústavu a chce ich aktívne využívať. Samoobslužný režim vo VODD vníma veľmi pozitívne ako možnú prípravu na samostatný život na slobode.",
        ],
      },

      hodnotenie_postoja_odsudeneho: {
        nazov: "Hodnotenie postoja odsúdeného k jeho trestnej činnosti",
        texts: [
          "Spáchanie trestného činu, za ktorý je odsúdený vôbec neľutuje. Ak by sa znovu dostal do danej situácie, v ktorej trestný čin spáchal, reagoval by zrejme úplne rovnako, resp. vzhľadom k aktuálnym postojom a možným novým kriminálnym zručnostiam je presvedčený, že „teraz by mu to prešlo“. Explicitne či implicitne vyjadruje ľahostajnosť k následkom trestného činu, nebadať známky rozpakov či viny v súvislosti s predošlou trestnou činnosťou, resp. je na svoj čin hrdý.",
          "Spáchanie trestného činu odsúdený neľutuje, resp. ľutuje len formálne. Jeho súčasné postoje, myslenie a správanie naznačujú, že by sa pravdepodobne zachoval podobne alebo rovnako.",
          "Nevie zaujať stanovisko k spáchaniu trestného činu, za ktorý je odsúdený. Ak zvážime postoj odsúdeného k trestnému činu, jeho aktuálne myslenie, zručnosti či osobnosť, je prítomné riziko, že by reagoval podobne v zmysle páchania trestnej činnosti.",
          "Spáchanie trestného činu, za ktorý je odsúdený ľutuje. Ak by sa dostal opäť do danej situácie, v ktorej trestný čin spáchal, je znížené riziko, že by sa zachoval rovnako.",
          "Spáchanie trestného činu, za ktorý je odsúdený, veľmi ľutuje. Ak by sa dostal opäť do danej situácie, v ktorej  trestný čin spáchal, s vysokou pravdepodobnosťou by sa nedopustil trestnej činnosti.",
        ],
      },

      realistickost_hodnotenia_vlastnej_rodinnej: {
        nazov: "Realistickosť hodnotenia vlastnej rodinnej situácie odsúdeného",
        texts: [
          "Veľmi nerealisticky hodnotí svoju rodinnú situáciu, vrátane správania a fungovania rodiny po jeho návrate z výkonu trestu. Príkladom veľmi nerealistického hodnotenia je predpoklad odsúdeného, že po návrate z výkonu trestu bude bývať u niekoho z rodiny, pričom s dotyčnou osobou počas výkonu trestu neudržiaval žiadne kontakty alebo mu rodina dala jasne najavo, že so scenárom návratu nepočíta. Iným príkladom veľmi nerealistického očakávania je, že sa jeho partner/ka a deti na neho tešia a že návrat a adaptačné obdobie bude prebiehať bez konfliktov a problémov. Menej častým, ale možným príkladom sú nerealisticky negatívne očakávania o vzťahoch s rodinou a jej členmi.",
          "Svoju rodinnú situáciu hodnotí z hľadiska viacerých aspektov skôr nerealisticky. Napr. má nerealisticky pozitívne očakávania ohľadom správania sa členov jeho rodiny k nemu po návrate aj o ich očakávaniach na jeho osobu, resp. nevníma potrebu zmeny správania zo svojej strany. V jeho hodnotení sú vzhľadom k reálnej rodinnej situácii aj realistické prvky hodnotenia jej fungovania a miesta odsúdeného v rodine.",
          "Svoju rodinnú situáciu hodnotí skôr realisticky. Má pomerne reálny odhad ako bude prebiehať obdobie po jeho návrate z výkonu trestu v rámci začleňovania sa do rodiny. Sú však oblasti, kde sú jeho hodnotenia a očakávania nerealistické, a/alebo nevníma potrebu znášať a riešiť konfliktné situácie, ktoré môže nová situácia priniesť.",
          "Svoju rodinnú situáciu hodnotí realisticky, vrátane primeraných očakávaní o správaní sa členov rodiny po jeho návrate z výkonu trestu. Pravdepodobne ale bude skôr pasívny z hľadiska snahy sa opätovne dobre začleniť do rodiny, resp. podnietiť nejaké pozitívne zmeny z hľadiska jej fungovania.",
          "Svoju rodinnú situáciu hodnotí veľmi realisticky a zároveň sa po prepustení bude usilovať o dobré opätovné začlenenie do rodiny a prípadné pozitívne zmeny v nej.",
        ],
      },

      realistickost_hodnotenia_osobnej_situacie: {
        nazov:
          "Realistickosť hodnotenia osobnej situácie odsúdeného  - zameraná na uvedomenie si osobných rizík v súvislosti s jeho správaním a osobnosťou",
        texts: [
          "Neuvedomuje si, resp. nerealisticky hodnotí svoje osobné identifikované rizikové faktory ako sú napr. impulzívne či agresívne správanie, nadmerná pasivita pri riešení problémov, parazitický životný štýl a pod., ani ich súvislosť so spáchaným trestným činom.",
          "Má prevažne nedostatočný náhľad na svoje zaužívané správanie a osobnostné vlastnosti, ktoré sú objektívne identifikované ako rizikové faktory (napr. impulzívne či agresívne správanie, nadmerná pasivita pri riešení problémov, parazitický životný štýl a pod.). Nedostatočne si uvedomuje súvislosť svojej osobnosti so spáchaným trestným činom.",
          "Má čiastočne realistický náhľad na svoje zaužívané správanie a osobnostné vlastnosti, ktoré sú objektívne identifikované ako rizikové faktory (napr. impulzívne či agresívne správanie, nadmerná pasivita pri riešení problémov, parazitický životný štýl a podobne).",
          "Uvedomuje si a prevažne realisticky hodnotí svoje osobné identifikované rizikové faktory, a pomerne realisticky vníma aj ich súvislosť so spáchaným trestným činom.",
          "Uvedomuje si a veľmi realisticky hodnotí identifikované rizikové faktory, ktoré súvisia s jeho zaužívaným správaním a osobnosťou, vrátane ich súvislosti so spáchaným trestným činom.",
        ],
      },

      motivacia_odsudeneho_k_zivotu_bez_recidivy: {
        nazov: "Motivácia odsúdeného k životu bez recidívy",
        texts: [
          "Je v odpore, o zmene po VTOS neuvažuje. Nezaujíma sa o motivačné faktory a príčiny správania, ktoré viedli k trestnej činnosti, k odsúdeniu a VTOS, prípadne tieto príčiny vyslovene externalizuje (vinu kladie okoliu, spoločnosti, zhode okolností a podobne). Celkovo sa dá konštatovať, že u odsúdeného je negatívna alebo chýbajúca motivácia k životu bez recidívy.",
          "Komunikuje svoju trestnú činnosť ako „náhodu“ resp. externalizuje príčiny, ktoré viedli k jeho predošlej trestnej činnosti. Nie je ochotný a/alebo schopný reflektovať svoje správanie a motiváciu a je celkovo len málo motivovaný k životu bez recidívy. Z rozhovoru s odsúdeným a iných dostupných zdrojov vyplýva, že jeho motivácia k životu bez recidívy je viac negatívna a skôr nedostatočná pre úsilie o život bez recidívy.",
          "Jeho postoj k životu bez recidívy je nejasný, alebo sa u odsúdeného vo vzťahu k budúcej trestnej činnosti vyskytujú významne pozitívne aj negatívne motivačné faktory. Motivácia odsúdeného k životu bez recidívy je vo výsledku neprehľadná, ťažko určiteľná, s pozitívnymi aj rizikovými faktormi, ktoré vo výsledku vedú k tomu, že u odsúdeného nie je možné určiť prevahu pozitívnych vs rizikových motivačných faktorov k životu bez recidívy.",
          "Je podnietený k zmene, má predstavu o tom, akým rizikovým faktorom sa v budúcnosti vyhnúť, má tendenciu na sebe pracovať smerom k posilneniu a aj ďalšiemu zlepšovaniu svojej motivácie pre život bez recidívy, resp. k aktívnemu znižovaniu vlastných rizikových faktorov. U odsúdeného vo výsledku prevažujú pozitívne faktory motivácie k životu bez recidívy.",
          "Je motivovaný k zmene a ako ju je možné dosiahnuť. Má zároveň jasnú a realistickú predstavu o svojich rizikových motivačných faktoroch a spôsobom akými vyplývajúce riziká znižovať. Z pohľadu hodnotiteľa je motivácia odsúdeného pre život bez recidívy realisticky pozitívna, nielen účelovo alebo seba-zavádzajúco deklarovaná. Motivácia odsúdeného k životu bez recidívy je veľmi pozitívna. ",
        ],
      },

      plan_zivota_po_prepusteni: {
        nazov: "Plán života po prepustení",
        texts: [
          "Má výrazne nerealistický plán života po prepustení. Napríklad odsúdený sa nerealisticky spolieha na svoju rodinu/blízkych/kamarátov (zabezpečia ho finančne a budú sa o neho starať) alebo nerealisticky pozitívne vníma svoje šance sa zamestnať a vyhýbať sa ďalšej trestnej činnosti. Opis jeho krokov po prepustení je veľmi všeobecný a nepremyslený. Za nerealistický plán považujeme aj alternatívu, ak odsúdený prejavuje prehnane pesimistické očakávania (nikto ma nezamestná, všetci ma nenávidia, určite sa vrátim do basy aj keď nechcem, mne už nič nepomôže a pod.).",
          "Má prevažne nerealistický plán života po prepustení. Nevie bližšie špecifikovať svoj plán po prepustení, o zabezpečenie bývania a financovania sa zaujíma nedostatočne, nerealisticky očakáva pomoc okolia.",
          "Má čiastočne realistický plán života po prepustení aspoň v niektorých oblastiach života (rodina, blízki, práca a i.) a vie realisticky opísať aspoň niektoré kroky, ako bude postupovať po návrate z VTOS. Svoje možnosti bývania a financovania vie čiastočne ohodnotiť, spolieha sa však na pomoc rodiny.",
          "Má pomerne špecifický a realistický plán, ako bude fungovať po prepustení z VTOS, vrátane možností bývania, vzťahov s rodinou, zabezpečenia financovania či zamestnania sa a pod. Nemá však premyslené alternatívy, ak by sa veci vyvíjali inak, ako si naplánoval.",
          "Má výrazne špecifický a realistický plán, kam budú smerovať jeho kroky po prepustení z VTOS. Vie reálne ohodnotiť svoje možnosti bývania aj financovania, vzťahy s rodinou a kamarátmi. Pozná svoje možnosti, zodpovednosti a povinnosti. Má aj „plán B“, keby veci nevychádzali, ako si ich naplánoval.",
        ],
      },

      hodnotenie_urovne_socialnej_komunikacie: {
        nazov: "Hodnotenie úrovne sociálnej komunikácie u odsúdeného",
        texts: [
          "Vykazuje veľmi zlé schopnosti v rámci sociálnej komunikácie či po verbálnej, alebo neverbálnej stránke. Nedokáže chápať perspektívu druhej strany, správne vyhodnocovať verbálnu a neverbálnu komunikáciu a prípadné rozpory medzi nimi. Počúva výrazne nepozorne, často skáče do reči, na otázky buď nereaguje, alebo reaguje prehnane, alebo neprimerane. Aj pri napomínaní a snahe o usmernenie je komunikácia s odsúdeným veľmi náročná.",
          "Vykazuje horšie schopnosti v rámci sociálnej komunikácie. Dokáže čiastočne počúvať, na otázky však reaguje buď prehnane agresívne, defenzívne, manipulatívne alebo úplne pasívne. Nesprávne alebo s ťažkosťami rozumie a prijíma perspektívu druhej strany. Bežne sa objavuje výrazný rozpor medzi verbálnou a neverbálnou komunikáciou. Napomínanie či usmerňovanie odsúdeného v priebehu interakcie dočasne napomáha k lepšej sociálnej komunikácii. V komunikácii neprejavuje žiadnu úctu či rešpekt voči odborníkovi s ktorým komunikuje.",
          "Vykazuje priemerné schopnosti v rámci sociálnej komunikácie. Aktívne počúva a primerane reaguje len v oblastiach, ktoré ho zaujímajú. V prípade, že ho téma konverzácie nezaujíma, nevie sa situácii dostatočne prispôsobiť, či sám komunikáciu efektívne presmerovať a reaguje stratou záujmu. Ťažšie prijíma zmeny v obsahu konverzácie, horšie vníma potreby a perspektívu druhej strany.  V jeho verbálnej a neverbálnej komunikácii s druhou osobou sa bežne objavujú nedostatky, ktoré znižujú kvalitu výslednej komunikácie, máva problém udržať tempo a obsahovú niť konverzácie.",
          "Vykazuje dobré schopnosti v rámci sociálnej komunikácie. Dokáže aktívne počúvať, dostatočne vnímať aj neverbálne prejavy osoby, s ktorou komunikuje a vnímať perspektívu druhej strany. Na otázky reaguje primerane, v jeho verbálnej a neverbálnej komunikácii je opakovane prítomný nesúlad, ktorý zhoršuje úroveň jeho komunikácie s druhými.",
          "Vykazuje veľmi dobré schopnosti v rámci sociálnej komunikácie. Dokáže aktívne počúvať a uvedomovať si aj perspektívu druhej strany v komunikácii. Vie komunikáciu aj dobre rozvíjať, aj sa dostatočne prispôsobiť zmenám v obsahu, či potrebám, ktoré v komunikácii vyjadruje druhá strana. Jeho neverbálna komunikácia väčšinou zodpovedá verbálnemu prejavu. Dokáže prijať aj negatívne reakcie druhej strany, napr. nepochopenie, odmietnutie, kritiku, agresiu či iné negatívne reakcie. Voči komunikačnému partnerovi sa správa s náležitou úctou.",
        ],
      },

      zaverecne_hodnotenie: {
        nazov: "Záverečné hodnotenie progresu u odsúdeného po pobyte vo VODD",
        texts: [
          "Bez zlepšenia - Pobyt vo VODD neviedol u odsúdeného k žiadnemu pozorovateľnému zlepšeniu. Nevyužil ponúkané možnosti na zlepšenie kompetencií a vedomostí potrebných pre lepšiu adaptáciu na život na slobode a/alebo sa už z hľadiska svojho potenciálu k zmene nemal kam posunúť k lepšiemu.",
          "S minimálnym zlepšením - Pobyt vo VODD viedol u odsúdeného k minimálnemu zlepšeniu kompetencií a vedomostí potrebných pre lepšiu adaptáciu na život na slobode.",
          "S miernym zlepšením - Počas pobytu vo VODD došlo u odsúdeného k miernemu zlepšeniu kompetencií a vedomostí potrebných pre lepšiu adaptáciu na život na slobode.",
          "S citeľným zlepšením - Počas pobytu vo VODD došlo u odsúdeného k citeľnému zlepšeniu kompetencií a vedomostí potrebných pre lepšiu adaptáciu na život na slobode.",
          "S výrazným zlepšením - Počas pobytu vo VODD došlo u odsúdeného k výraznému zlepšeniu kompetencií a vedomostí potrebných pre lepšiu adaptáciu na život na slobode.",
        ],
      },
    },
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    showDialog(x) {
      this.dialog = true;
      this.dialog_item.nazov = this.dialogs[x].nazov;
      this.dialog_item.texty = this.dialogs[x].texts;
    },
    getItem() {
      apiService.getGeneralSkalyPo(this.$route.params.id).then((response) => {
        this.form = response;
      });
    },

    updateItem() {
      apiService.updateGeneralSkalyPo(this.form, this.$route.params.id).then(
        response => {
          this.form = response;
          this.snackbar_saved = true;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    closeItem() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť tento formulár? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;
            this.updateItem();
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },
  },
};
</script>